/**
 * SSE流处理函数
 * 负责解析SSE事件并分发给事件处理器
 */

import { handleStreamingEventAtom } from './eventHandler';

// SSE流处理函数
export async function processSSEStream(
  response: Response,
  _get: (atom: any) => any,
  set: (atom: any, value: any) => void,
  _conversationId: string | null | undefined
): Promise<void> {
  const reader = response.body?.getReader();
  const decoder = new TextDecoder();

  if (!reader) {
    throw new Error('无法读取响应流');
  }

  let buffer = '';
  let isReading = true;

  // 添加智能超时机制 - 30秒无数据则超时
  const inactivityTimeoutMs = 30 * 1000; // 30秒
  let inactivityTimeoutId: NodeJS.Timeout | null = null;

  const resetInactivityTimeout = () => {
    if (inactivityTimeoutId) {
      clearTimeout(inactivityTimeoutId);
    }
    inactivityTimeoutId = setTimeout(() => {
      console.warn('SSE流30秒无数据，认为连接异常，关闭连接');
      isReading = false;
      reader.cancel().catch(err => console.error('取消reader失败:', err));
    }, inactivityTimeoutMs);
  };

  // 初始设置超时
  resetInactivityTimeout();

  try {
    while (isReading) {
      const { done, value } = await reader.read();

      if (done) {
        if (inactivityTimeoutId) clearTimeout(inactivityTimeoutId);
        isReading = false;
        break;
      }

      // 收到数据，重置超时计时器
      resetInactivityTimeout();

      buffer += decoder.decode(value, { stream: true });

      // 处理缓冲区中的事件 - 改进的SSE解析逻辑
      const lines = buffer.split('\n\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.trim() === '' || line.startsWith(':')) continue;

        // 解析事件 - 更健壮的解析方式
        const eventLines = line.split('\n');
        let eventType = 'message';
        let eventData = '';

        for (const eventLine of eventLines) {
          if (eventLine.startsWith('event:')) {
            eventType = eventLine.substring(6).trim();
          } else if (eventLine.startsWith('data:')) {
            // 获取data:后的所有内容，包括可能的多行数据
            eventData = eventLine.substring(5).trim();
            break;
          }
        }

        // 处理事件
        if (eventData) {
          try {
            const parsedData = JSON.parse(eventData);

            // 使用新的事件处理器，简化逻辑
            set(handleStreamingEventAtom, { type: eventType, data: parsedData });

          } catch (error) {
            console.error('解析事件数据失败:', error);
          }
        }
      }
    }
  } finally {
    // 清理超时定时器
    if (inactivityTimeoutId) {
      clearTimeout(inactivityTimeoutId);
    }
  }
}
